import { render } from "./NAttachmentsDropArea.vue?vue&type=template&id=6deddba8&ts=true"
import script from "./NAttachmentsDropArea.vue?vue&type=script&lang=ts"
export * from "./NAttachmentsDropArea.vue?vue&type=script&lang=ts"

import "./NAttachmentsDropArea.vue?vue&type=style&index=0&id=6deddba8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__